import axiosInstance from 'utils/axiosInstance';
import {
  CalendarEvent,
  DataIndexType,
  Effectif,
  FiltersTimeline,
  Resources,
} from '../../conge/types/timeline';
import { ExportFilterType } from '../types/leaveRequestType';

export const GetResourcesTimeLine = async (
  filter: FiltersTimeline,
): Promise<Resources[]> => {
  const { data } = await axiosInstance.post<ApiResponse<Resources[]>>(
    'api/congee/GetResources',
    filter,
  );
  return data.data;
};

export const GetEventsTimeLine = async (
  filter: FiltersTimeline,
): Promise<CalendarEvent[]> => {
  const { data } = await axiosInstance.post<ApiResponse<CalendarEvent[]>>(
    'api/congee/GetEvents',
    filter,
  );
  return data.data;
};

export const GetEffectifTimeLine = async (
  filter: FiltersTimeline,
): Promise<Effectif> => {
  const { data } = await axiosInstance.post<ApiResponse<Effectif>>(
    'api/congee/GetEffectif',
    filter,
  );
  return data.data;
};

export const GetDataIndex = async (): Promise<ApiResponse<DataIndexType>> => {
  const { data } = await axiosInstance.get('api/congee/GetDataIndex');
  return data;
};

export const GetDataIndexServices = async (): Promise<DataIndexType> => {
  const { data } = await axiosInstance.get<ApiResponse<DataIndexType>>(
    'api/congee/GetDataIndex',
  );
  return data.data;
};

export const ExportCongeServices = async (
  filter: ExportFilterType,
): Promise<ArrayBuffer> => {
  const { data } = await axiosInstance.post<ArrayBuffer>(
    '/api/congee/ExportConge',
    filter,
    {
      responseType: 'arraybuffer',
    },
  );
  return data;
};
